// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Te1e","delete":"styles_delete__36HYX","update":"styles_update__3H52R","add":"styles_add__5aYN5"};